import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Colleges = () => {
  const { id } = useParams();
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    const getProgramsByCollegeId = async () => {
      try {
        const res = await fetch(`https://plo.areez.co/api/plo/programs/summary?page=1&per_page=5&name=&college_id=${id}`);
        const data = await res.json();
        setPrograms(data.data);
      } catch (error) {
        console.error("فشل جلب البرامج:", error);
      }
    };

    getProgramsByCollegeId();
  }, [id]);

  const handleCompare = (program) => {
    const programId = program.program_id || program.id;
    window.location.href  = `/programs/compare/${programId}`;
  };

  const bgColors = {
    Excellent: "bg-success",
    Good: "bg-info",
    Acceptable: "bg-secondary",
    Weak: "bg-danger",
    null: "bg-warning",
  };

  return (
    <div className="row mt-5">
      {programs.map((program) => {
        const classification = program.classification || "null";
        const cardClass = bgColors[classification] || "bg-light";

        return (
          <div
            className="col-xl-3 col-lg-6 col-sm-6"
            key={program.program_id}
            onClick={() => handleCompare(program)}
            style={{ cursor: "pointer" }}
          >
            <div className={`widget-stat card ${cardClass}`}>
              <div className="card-body p-4">
                <div className="media">
                  <span className="mr-3">
                    <i className="la la-book"></i>
                  </span>
                  <div className="media-body text-white">
                    <p className="mb-1">{program.program_code}</p>
                    <h4 className="text-white">{program.program_name}</h4>

                    {program.average_pct !== null ? (
                      <>
                        <div className="progress mb-2 bg-white">
                          <div
                            className="progress-bar progress-animated"
                            style={{ width: `${program.average_pct}%` }}
                          ></div>
                        </div>
                        <small>{program.average_pct.toFixed(2)}% - {program.classification}</small>
                      </>
                    ) : (
                      <small>لا توجد بيانات حالياً</small>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Colleges;
